import { useState, type FormEvent } from 'react'
import { useAnmeldung } from '../lib/anmeldung'
import { ApiFehler } from '../lib/api'

export function AnmeldungSeite() {
  const { anmelden, abgelaufen } = useAnmeldung()
  const [email, setzeEmail] = useState('')
  const [passwort, setzePasswort] = useState('')
  const [fehler, setzeFehler] = useState<string | null>(null)
  const [laeuft, setzeLaeuft] = useState(false)

  async function absenden(ereignis: FormEvent) {
    ereignis.preventDefault()
    setzeFehler(null)
    setzeLaeuft(true)
    try {
      await anmelden(email, passwort)
    } catch (problem) {
      setzeFehler(problem instanceof ApiFehler ? problem.message : 'Die Anmeldung hat nicht geklappt.')
    } finally {
      setzeLaeuft(false)
    }
  }

  return (
    <div className="anmeldung-seite">
      <div className="anmeldung-spalte">
        <div className="anmeldung-marke">
          <div className="wortmarke">
            H&amp;K <span>Automation</span>
          </div>
          <div className="werkzeug">Kreditkarten · Anmeldung</div>
        </div>

        <form onSubmit={(e) => void absenden(e)}>
          {fehler && <div className="fehler">{fehler}</div>}
          {!fehler && abgelaufen && <div className="hinweis abstand-unten">Die Sitzung ist abgelaufen. Bitte neu anmelden.</div>}

          <div>
            <label htmlFor="email">E-Mail</label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              autoFocus
              required
              value={email}
              onChange={(e) => setzeEmail(e.target.value)}
            />
          </div>

          <div>
            <label htmlFor="passwort">Passwort</label>
            <input
              id="passwort"
              type="password"
              autoComplete="current-password"
              required
              value={passwort}
              onChange={(e) => setzePasswort(e.target.value)}
            />
          </div>

          <button type="submit" className="knopf gefuellt" disabled={laeuft}>
            {laeuft ? 'Wird geprüft …' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  )
}
